<template>
	<div class="formInputGroup">
		<textarea 
			class="inputField"
			:name="label"
			:id="label"
			v-model="inputVal"
			@input="onChange()"
			@change="$emit('input', inputVal)"
			:class="{'hasValue' : inputVal != '' && inputVal != undefined, 'errorPresent': error != undefined && error != ''}"
			rows="2"
			ref="textarea"
		>
		</textarea>
		<span class="bar"></span>
		<label 
			class="inputLabel"
			:class="{'errorPresent' : error != undefined && error != ''}"
			:for="label"
		>
			{{label}}<span v-if="required" class="required-indicator"> *</span>
		</label>
		<span
			:class="{'errorPresent' : error != undefined && error != ''}"
			v-if="error != undefined && error != ''"
		>
			{{error}}
		</span>
	</div>
</template>

<script>

export default {
	name: 'TextareaField',
	props: ['label', 'value', 'error', 'required'],
	components: {

	},
	$_veeValidate: {
		// fetch the current value from the innerValue defined in the component data.
		name() {
			return this.label;
		},
		value () {
			return this.inputVal;
		}
	},
	computed: {
		inputVal: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit('input', val);
			}
		}
	},
	methods: {
		onChange() {
			this.$refs.textarea.style.height = ""; /* Reset the height*/
  			this.$refs.textarea.style.height = this.$refs.textarea.scrollHeight + "px";
		}
	}
}
</script>

<style lang="scss" scoped></style>
